import styles from './Skeleton.module.css';

function Skeleton({ width, height, borderRadius = '4px', className = '', bgColor="white" }) {
  return (
    <div 
      // className={`skeleton ${className}`}
      className={styles.skeleton}
      style={{ 
        width: width || '100%', 
        height: height || '20px',
        borderRadius,
        backgroundColor: bgColor
      }}
    />
  );
}

export default Skeleton;